import { createContext, ReactNode, useState } from 'react'
import Partner from '../types/Partner'

type ContextType = {
  partnerDetails: Partner[]
  setPartnerDetails: (partnerDetails: Partner[]) => void
}

type PartnerProviderProps = {
  children: ReactNode
}

export const PartnerContext = createContext({} as ContextType)

export const PartnerProvider = ({ children }: PartnerProviderProps) => {
  const [partnerDetails, setPartnerDetails] = useState<Partner[]>([])

  return (
    <PartnerContext.Provider value={{ partnerDetails, setPartnerDetails }}>
      {children}
    </PartnerContext.Provider>
  )
}
